/**
 * Main Controller responsible for controlling the AutomationTab
 */
define(function (require) {
    "use strict";
    var AutomationLayout = require("automation-views/layouts/AutomationLayout");
    var LEResourceResolver = require("leResourceResolver");
    var AU_CONST = require("automation-const");
    var AutomationController = {};

    LE.module("LEAutomation", function (LEAutomation, LE, Backbone, Marionette, $, _) {
        var config = LE.getConfig();
        AutomationController = Marionette.Controller.extend({

            initialize: function () {
                this.automationLayout = new AutomationLayout();
                this.contextModel = LEAutomation.contextModel;
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this.contextModel, 'change:botplatform-iframe', this._authenticateBotPlatform);
                this.listenTo(this.contextModel, 'change:conversationbuilder-iframe', this._authenticateConvBuilder);
                this.listenTo(LEAutomation.vent, 'router:show-landing-page', this._showLandingPage);
                this.listenTo(LEAutomation.vent, 'router:show-conv-builder', this._showConvBuilderPage);
                this.listenTo(LEAutomation.vent, 'router:show-bot-platform', this._showBotPlatformPage);
            },

            _manageSelectedNav: function (model, selectedNav) {
                if (this.selectedTab !== selectedNav) {
                    this.selectedTab = selectedNav;
                    switch (selectedNav) {
                        case AU_CONST.NAV.CONV_BUILDER:
                            this._showConvBuilderPage();
                            break;
                        case AU_CONST.NAV.LANDING:
                            this._showLandingPage();
                            break;
                        case AU_CONST.NAV.BOT_PLATFORM:
                            this._showBotPlatformPage();
                            break;
                        default:
                            break;
                    }
                }
            },

            _showLandingPage: function () {
                this.automationLayout.activateLandingPage();
            },

            _showConvBuilderPage: function () {
                this.automationLayout.activateConvBuilderPage();
            },

            _showBotPlatformPage: function () {
                this.automationLayout.activateBotPlatformPage();
            },

            _authenticateBotPlatform: function (model, iframe) {
                var botPlatformDomain = LEResourceResolver.getUrl(LEResourceResolver.apiResources.botPlatformDomain);
                this._authenticateIFrame(iframe[0], botPlatformDomain, AU_CONST.NAMESPACES.BOT_PLATFORM);
            },

            _authenticateConvBuilder: function (model, iframe) {
                this._authenticateIFrame(iframe[0], config.botCentralDomain, AU_CONST.NAMESPACES.CONVERATION_BUILDER);
            },

            _authenticateIFrame: function (iframe, domain, namespace) {
                iframe.onload = function () {
                    var window = this.contentWindow;
                    var action = 'authenticate';
                    var payload = JSON.stringify({
                        accountId: LE.sessionManager.getAccountId(),
                        bearer: LE.sessionManager.getGlob(),
                        checkLpa: LE.sessionManager.isLPA(),
                        lpZone: config.lp_zone,
                        ttl: LE.sessionManager.getSessionLifetime(),
                        userId: LE.sessionManager.getUserId()
                    });
                    var encodedPayload = btoa(payload);
                    var message = `${namespace}:${action}:${encodedPayload}`;
                    window.postMessage(message, domain);
                };
                iframe.src = domain;
            },

            getMainView: function () {
                return this.automationLayout;
            },

            showLoader: function () {
                this.automationLayout.showLoader();
            },

            hideLoader: function () {
                this.automationLayout.hideLoader();
            }
        });
    });
    return AutomationController;
});
